<div class="card" [ngClass]="{noBorder}">
  <div class="card-header">
    <div class="card-header-title">
      <h3 class="card-header-title-text">{{ title }}</h3>
      <p class="card-header-title-description">{{ description }}</p>
    </div>
    <div class="card-header-action">
      <ng-content select="[actions]"></ng-content>
    </div>
  </div>

  <div class="card-content flex-1">
    <ng-content select="[content]"></ng-content>
  </div>
</div>
